(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1693,7866],{

/***/ 5080:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/objects/map",
      function () {
        return __webpack_require__(5861);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5820);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8548);
/* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8509);
/* harmony import */ var react_portal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(779);
/* harmony import */ var _styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6458);
/* harmony import */ var _styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var Modal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var children = param.children, title = param.title, button = param.button, action = param.action, visibility = param.visibility, onOpen = param.onOpen, onClose = param.onClose, style = param.style;
    /** HANDLERS */ var showModal = function() {
        if (onOpen) onOpen();
        setTimeout(function() {
            return (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_2__/* .disableBodyScroll */ .Qp)(document.querySelector(".".concat((_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper))));
        });
    };
    var closeModal = function() {
        if (onClose) onClose();
        setTimeout(function() {
            return (0,body_scroll_lock__WEBPACK_IMPORTED_MODULE_2__/* .clearAllBodyScrollLocks */ .tP)();
        });
    };
    var closeOnEscapeKeyDown = function(e) {
        if ((e.charCode || e.keyCode) === 27) closeModal();
    };
    var handleBackgroundClick = function(e) {
        if (e.target.className === (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper)) closeModal();
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            show: function show() {
                showModal();
            },
            hide: function hide() {
                closeModal();
            },
            children: function children1() {
                return children;
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.addEventListener("keydown", closeOnEscapeKeyDown);
        return function() {
            return document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_portal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .AnimatePresence */ .M, {
            children: visibility && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                className: (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1,
                    transition: {
                        duration: 0.5
                    }
                },
                exit: {
                    opacity: 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
                    onClick: handleBackgroundClick,
                    style: style,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                        className: (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modal),
                        initial: window.innerWidth < 576 ? {
                            bottom: -700
                        } : {
                            opacity: 0,
                            y: "100%"
                        },
                        animate: window.innerWidth < 576 ? {
                            bottom: 0,
                            transition: {
                                delay: 0.2
                            }
                        } : {
                            opacity: 1,
                            y: "0%",
                            transition: {
                                delay: 0.2
                            }
                        },
                        exit: {
                            opacity: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.button */ .E.button, {
                                className: (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalClose),
                                type: "button",
                                onClick: closeModal,
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1,
                                    transition: {
                                        delay: 0.5
                                    }
                                },
                                exit: {
                                    opacity: 0
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "40",
                                    height: "40",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            }),
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalTitle),
                                children: title
                            }),
                            children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalContent),
                                children: children
                            }),
                            button && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: [
                                    (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modalButton),
                                    (_styles_modules_Modal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fullWidth)
                                ].join(" "),
                                title: "Закрыть",
                                type: "button",
                                onClick: action,
                                children: button
                            })
                        ]
                    })
                })
            })
        })
    });
});
Modal.displayName = "Modal";
/* harmony default export */ __webpack_exports__["default"] = (Modal);


/***/ }),

/***/ 5861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ map; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Header.js + 4 modules
var Header = __webpack_require__(798);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-yandex-maps/dist/production/react-yandex-maps.esm.js
var react_yandex_maps_esm = __webpack_require__(8112);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(5518);
// EXTERNAL MODULE: ./helpers/index.js
var helpers = __webpack_require__(3725);
// EXTERNAL MODULE: ./node_modules/@turf/clean-coords/dist/es/index.js
var es = __webpack_require__(7407);
// EXTERNAL MODULE: ./node_modules/@turf/unkink-polygon/dist/es/index.js + 2 modules
var dist_es = __webpack_require__(5642);
// EXTERNAL MODULE: ./node_modules/@turf/combine/dist/es/index.js
var combine_dist_es = __webpack_require__(9169);
// EXTERNAL MODULE: ./node_modules/@turf/buffer/dist/es/index.js + 67 modules
var buffer_dist_es = __webpack_require__(6039);
// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./context/objects.js
var objects = __webpack_require__(1563);
// EXTERNAL MODULE: ./hooks/useIsMount.js
var useIsMount = __webpack_require__(9766);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(8548);
// EXTERNAL MODULE: ./components/Skelet.js
var Skelet = __webpack_require__(3177);
// EXTERNAL MODULE: ./styles/modules/objects/ObjectsMapCatalogItem.module.scss
var ObjectsMapCatalogItem_module = __webpack_require__(2342);
var ObjectsMapCatalogItem_module_default = /*#__PURE__*/__webpack_require__.n(ObjectsMapCatalogItem_module);
;// CONCATENATED MODULE: ./components/objects/ObjectsMapCatalogSkeletonItem.js



var ObjectsMapCatalogSkeletonItem = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ObjectsMapCatalogItem_module_default()).item,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ObjectsMapCatalogItem_module_default()).itemGallery,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                    style: {
                        height: "100%",
                        borderRadius: 16,
                        margin: 2,
                        width: "auto"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ObjectsMapCatalogItem_module_default()).itemData,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                        className: (ObjectsMapCatalogItem_module_default()).itemPrice,
                        height: 36,
                        maxWidth: 200
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                        className: (ObjectsMapCatalogItem_module_default()).itemAddress,
                        height: 21,
                        maxWidth: 240
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ObjectsMapCatalogItem_module_default()).itemProperties,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                                className: (ObjectsMapCatalogItem_module_default()).itemProperty,
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                                className: (ObjectsMapCatalogItem_module_default()).itemProperty,
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                                className: (ObjectsMapCatalogItem_module_default()).itemProperty,
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ObjectsMapCatalogItem_module_default()).itemActions,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            height: 50,
                            style: {
                                borderRadius: 12,
                                width: "100%"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var objects_ObjectsMapCatalogSkeletonItem = (ObjectsMapCatalogSkeletonItem);

// EXTERNAL MODULE: ./components/Input.js
var Input = __webpack_require__(1121);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(2077);
// EXTERNAL MODULE: ./styles/modules/objects/ObjectsMapCatalogCommercialItem.module.scss
var ObjectsMapCatalogCommercialItem_module = __webpack_require__(8960);
var ObjectsMapCatalogCommercialItem_module_default = /*#__PURE__*/__webpack_require__.n(ObjectsMapCatalogCommercialItem_module);
;// CONCATENATED MODULE: ./components/objects/ObjectsMapCatalogCommercialItem.js








var Modal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var ObjectsMapCatalogCommercialItem = function() {
    /** STATES */ var locationState = (0,context_location/* useLocationState */.KJ)();
    var ref = (0,react.useState)(false), isModalFeedbackVisible = ref[0], setIsModalFeedbackVisible = ref[1];
    var ref1 = (0,react.useState)(false), isModalSuccessVisible = ref1[0], setIsModalSuccessVisible = ref1[1];
    var ref2 = (0,react.useState)(""), clientName = ref2[0], setClientName = ref2[1];
    var ref3 = (0,react.useState)(""), clientPhone = ref3[0], setClientPhone = ref3[1];
    var clientNameId = (0,react.useRef)();
    var clientPhoneId = (0,react.useRef)();
    /** HANDLERS */ var handleFormSubmit = function() {
        clientNameId.current.setError(clientName.length <= 3);
        clientPhoneId.current.setError(clientPhone.length !== 11);
        if (clientName.length > 3 && clientPhone.length === 11) {
            setIsModalCallVisible(false);
            setIsModalSuccessVisible(true);
            axios_default().post("https://baza.estate/api/v2" + "/client", {
                clientName: clientName,
                clientPhone: clientPhone,
                pathName: window.location.pathname,
                whatComponent: "ObjectsMapCatalogCommercialItem",
                location: locationState.region,
                platform: "web"
            });
        }
    };
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ObjectsMapCatalogCommercialItem_module_default()).commercial,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                title: "Заявка на подбор",
                visibility: isModalSuccessVisible,
                onClose: function() {
                    return setIsModalSuccessVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Спасибо за вашу заявку. Мы скоро с Вами свяжемся!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/man-with-message.svg",
                        alt: "",
                        style: {
                            margin: 32
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
                title: "Заявка на подбор",
                button: "Отправить",
                action: handleFormSubmit,
                visibility: isModalFeedbackVisible,
                onClose: function() {
                    return setIsModalFeedbackVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, подберем лучшие объекты!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        title: "Имя",
                        inputs: [
                            {
                                placeholder: "Иван Петрович",
                                value: clientName,
                                type: "text"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientNameId,
                        onChange: function(v) {
                            return setClientName(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        title: "Телефон",
                        inputs: [
                            {
                                placeholder: locationState.phone,
                                value: clientPhone,
                                mask: "phone",
                                type: "tel"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientPhoneId,
                        onChange: function(v) {
                            return setClientPhone(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            textAlign: "center",
                            opacity: 0.8,
                            fontSize: 14,
                            margin: "18px 0"
                        },
                        children: [
                            "Вы соглашаетесь с",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/faq/policy",
                                target: "_blank",
                                children: "политикой конфиденциальности"
                            }),
                            " ",
                            "при отправке данной формы к нам в работу"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ObjectsMapCatalogCommercialItem_module_default()).commercialContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ObjectsMapCatalogCommercialItem_module_default()).comemrcialTitle,
                        children: "Не нашли подходящего варианта?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ObjectsMapCatalogCommercialItem_module_default()).comemrcialDescription,
                        children: "Оставьте заявку на подбор объекта из закрытой базы нашим специалистам!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                color: "white",
                style: {
                    fontSize: 18,
                    fontWeight: 600,
                    padding: "12px 18px",
                    flexShrink: 0
                },
                onClick: function() {
                    return setIsModalFeedbackVisible(true);
                },
                children: "Подобрать варианты"
            })
        ]
    });
};
/* harmony default export */ var objects_ObjectsMapCatalogCommercialItem = (ObjectsMapCatalogCommercialItem);

// EXTERNAL MODULE: ./styles/modules/objects/ObjectsMapCatalog.module.scss
var ObjectsMapCatalog_module = __webpack_require__(2601);
var ObjectsMapCatalog_module_default = /*#__PURE__*/__webpack_require__.n(ObjectsMapCatalog_module);
;// CONCATENATED MODULE: ./components/objects/ObjectsMapCatalog.js


















var ObjectsMapCatalogItem = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3012), __webpack_require__.e(5641)]).then(__webpack_require__.bind(__webpack_require__, 5641));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5641)
            ];
        }
    },
    suspense: true
});
var ObjectsMapCatalog = function() {
    /** STATES */ var locationState = (0,context_location/* useLocationState */.KJ)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,objects/* useObjectsProvider */.v8)(), 2), objectsState = ref[0], setObjectsState = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isError = ref2[0], setIsError = ref2[1];
    var ref3 = (0,react.useState)(null), data = ref3[0], setData = ref3[1];
    var ref4 = (0,react.useState)(null), total = ref4[0], setTotal = ref4[1];
    /** REFS */ var catalogEl = (0,react.useRef)(null);
    /** FUNCTIONS */ var handleOnCloseClick = function() {
        setObjectsState({
            type: "SET_FILTER",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter), {
                ads: []
            })
        });
        setObjectsState({
            type: "SET_STATE",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.state), {
                isMapCatalogVisible: false
            })
        });
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        if (!objectsState.state.isMapCatalogVisible) return;
        if (catalogEl.current) catalogEl.current.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsLoading(true);
                            _ctx.next = 4;
                            return (0,helpers/* sleep */._v)(300);
                        case 4:
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/objects", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.sorting, objectsState.map), {
                                location: locationState.region,
                                page: 1,
                                length: 100
                            }), {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setTotal(response.data.data.total);
                            setData(response.data.data.data);
                            setIsLoading(false);
                            setIsError(false);
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.code !== "ERR_CANCELED") {
                                setIsLoading(false);
                                setIsError(true);
                            }
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        objectsState.filter
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
        initial: false,
        animate: {
            x: objectsState.state.isMapCatalogVisible ? 0 : -500,
            transition: {
                duration: 0.5
            }
        },
        className: (ObjectsMapCatalog_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                title: "Закрыть список",
                className: (ObjectsMapCatalog_module_default())["switch"],
                onClick: handleOnCloseClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                            x1: "18",
                            y1: "6",
                            x2: "6",
                            y2: "18"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                            x1: "6",
                            y1: "6",
                            x2: "18",
                            y2: "18"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ObjectsMapCatalog_module_default()).catalog,
                style: {
                    overflow: isLoading || isError ? "hidden" : "auto"
                },
                ref: catalogEl,
                children: isLoading || isError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                                height: 26,
                                style: {
                                    maxWidth: "240px",
                                    width: "100%",
                                    margin: "18px auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ObjectsMapCatalog_module_default()).catalogContent,
                            children: (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogSkeletonItem, {}, index);
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ObjectsMapCatalog_module_default()).catalogHeader,
                            children: [
                                (0,helpers/* declOfNum */.Ak)(total, [
                                    objectsState.filter.category === "дом" || objectsState.filter.category === "участок" ? "Найден" : "Найдена",
                                    "Найдено",
                                    "Найдено"
                                ]),
                                " ",
                                total,
                                " ",
                                (0,helpers/* categoryCaseConverter */.J5)(objectsState.filter.category, total)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ObjectsMapCatalog_module_default()).catalogContent,
                            children: data.map(function(value, index) {
                                if (data.length >= 4 && index > 4 && index % 5 === 0) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogSkeletonItem, {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsMapCatalogItem, {
                                                item: value
                                            })
                                        })
                                    }, index);
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogSkeletonItem, {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsMapCatalogItem, {
                                        item: value
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var objects_ObjectsMapCatalog = (ObjectsMapCatalog);

// EXTERNAL MODULE: ./components/Modal.js
var components_Modal = __webpack_require__(2280);
// EXTERNAL MODULE: ./styles/modules/objects/ObjectsMapCatalogMobile.module.scss
var ObjectsMapCatalogMobile_module = __webpack_require__(8060);
var ObjectsMapCatalogMobile_module_default = /*#__PURE__*/__webpack_require__.n(ObjectsMapCatalogMobile_module);
;// CONCATENATED MODULE: ./components/objects/ObjectsMapCatalogMobile.js

















var ObjectsMapCatalogMobile_ObjectsMapCatalogItem = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3012), __webpack_require__.e(5641)]).then(__webpack_require__.bind(__webpack_require__, 5641));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5641)
            ];
        }
    },
    suspense: true
});
var ObjectsMapCatalogMobile = function() {
    /** STATES */ var locationState = (0,context_location/* useLocationState */.KJ)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,objects/* useObjectsProvider */.v8)(), 2), objectsState = ref[0], setObjectsState = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isError = ref2[0], setIsError = ref2[1];
    var ref3 = (0,react.useState)(null), data = ref3[0], setData = ref3[1];
    var ref4 = (0,react.useState)(null), total = ref4[0], setTotal = ref4[1];
    /** FUNCTIONS */ var handleOnClose = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setObjectsState({
                            type: "SET_FILTER",
                            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter), {
                                ads: []
                            })
                        });
                        setObjectsState({
                            type: "SET_STATE",
                            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.state), {
                                isMapCatalogVisible: false
                            })
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnClose() {
            return _ref.apply(this, arguments);
        };
    }();
    /** HOOKS */ (0,react.useEffect)(function() {
        if (!objectsState.state.isMapCatalogVisible) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsLoading(true);
                            _ctx.next = 4;
                            return (0,helpers/* sleep */._v)(300);
                        case 4:
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/objects", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.sorting, objectsState.map), {
                                location: locationState.region,
                                page: 1,
                                length: objectsState.pagination.length
                            }), {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setTotal(response.data.data.total);
                            setData(response.data.data.data);
                            setIsLoading(false);
                            setIsError(false);
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.code !== "ERR_CANCELED") {
                                setIsLoading(false);
                                setIsError(true);
                            }
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        objectsState.filter
    ]);
    /** TEMPLATES */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal["default"], {
        visibility: objectsState.state.isMapCatalogVisible,
        onClose: handleOnClose,
        style: {
            overflow: isLoading || isError ? "hidden" : "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ObjectsMapCatalogMobile_module_default()).catalog,
            children: isLoading || isError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            height: 26,
                            style: {
                                maxWidth: "240px",
                                width: "100%",
                                margin: "8px auto 18px auto"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ObjectsMapCatalogMobile_module_default()).catalogContent,
                        style: {
                            height: 300
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogSkeletonItem, {})
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ObjectsMapCatalogMobile_module_default()).catalogHeader,
                        children: [
                            (0,helpers/* declOfNum */.Ak)(total, [
                                objectsState.filter.category === "дом" || objectsState.filter.category === "участок" ? "Найден" : "Найдена",
                                "Найдено",
                                "Найдено"
                            ]),
                            " ",
                            total,
                            " ",
                            (0,helpers/* categoryCaseConverter */.J5)(objectsState.filter.category, total)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ObjectsMapCatalogMobile_module_default()).catalogContent,
                        children: data.map(function(value, index) {
                            if (data.length >= 4 && index > 4 && index % 5 === 0) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogSkeletonItem, {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsMapCatalogMobile_ObjectsMapCatalogItem, {
                                                item: value
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogCommercialItem, {})
                                    ]
                                }, index);
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogSkeletonItem, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsMapCatalogMobile_ObjectsMapCatalogItem, {
                                    item: value
                                })
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var objects_ObjectsMapCatalogMobile = (ObjectsMapCatalogMobile);

// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(7080);
// EXTERNAL MODULE: ./styles/modules/objects/ObjectsMap.module.scss
var ObjectsMap_module = __webpack_require__(2901);
var ObjectsMap_module_default = /*#__PURE__*/__webpack_require__.n(ObjectsMap_module);
;// CONCATENATED MODULE: ./public/images/filter.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.63.18H1.37a1 1 0 0 0-1 1V5a1 1 0 0 0 1 1H2l7.27 9.1v7.69a1 1 0 0 0 1 1h3.44a1 1 0 0 0 1-1v-7.66L22 6h.64a1 1 0 0 0 1-1V1.18a1 1 0 0 0-1.01-1Zm-9.91 14.6v7h-1.44v-7a1 1 0 0 0-.22-.62L4.57 6h14.86l-6.49 8.13a1 1 0 0 0-.22.65ZM2.37 4V2.18h19.26V4H2.37Z"
  })));
};
/* harmony default export */ var filter = ((/* unused pure expression or super */ null && (SvgFilter)));
;// CONCATENATED MODULE: ./public/images/loupeplus.svg
var loupeplus_path, _path2;
function loupeplus_extends() { loupeplus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loupeplus_extends.apply(this, arguments); }

var SvgLoupeplus = function SvgLoupeplus(props) {
  return /*#__PURE__*/React.createElement("svg", loupeplus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    strokeWidth: 2
  }, props), loupeplus_path || (loupeplus_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.87 3.12a10 10 0 0 0-17.14 7.1 10.07 10.07 0 0 0 1.4 5.15L.47 20a1 1 0 0 0 0 1.41l2.07 2.08a1.05 1.05 0 0 0 .71.29 1 1 0 0 0 .75-.25l4.67-4.68a9.89 9.89 0 0 0 5.14 1.42 10 10 0 0 0 7.1-17.15ZM3.25 21.41l-.66-.67L6.34 17l.33.34c.11.11.22.21.33.33Zm16.21-5.5a8 8 0 1 1 2.36-5.69 8 8 0 0 1-2.36 5.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.33 10.22a1 1 0 0 1-1 1h-3.56v3.56a1 1 0 0 1-2 0v-3.56H9.22a1 1 0 0 1 0-2h3.55V5.67a1 1 0 1 1 2 0v3.55h3.56a1 1 0 0 1 1 1Z"
  })));
};
/* harmony default export */ var loupeplus = ((/* unused pure expression or super */ null && (SvgLoupeplus)));
;// CONCATENATED MODULE: ./public/images/loupeminus.svg
var loupeminus_path, loupeminus_path2;
function loupeminus_extends() { loupeminus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loupeminus_extends.apply(this, arguments); }

var SvgLoupeminus = function SvgLoupeminus(props) {
  return /*#__PURE__*/React.createElement("svg", loupeminus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    strokeWidth: 2
  }, props), loupeminus_path || (loupeminus_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.87 3.12a10 10 0 0 0-17.14 7.1 10 10 0 0 0 1.41 5.14L.47 20a1 1 0 0 0 0 1.41l2.07 2.08a1.05 1.05 0 0 0 .71.29 1 1 0 0 0 .75-.25l4.67-4.68a9.89 9.89 0 0 0 5.14 1.42 10 10 0 0 0 7.1-17.15ZM3.25 21.41l-.66-.67L6.34 17l.33.34c.11.11.22.21.33.33Zm16.21-5.5a8 8 0 1 1 2.36-5.69 8 8 0 0 1-2.36 5.69Z"
  })), loupeminus_path2 || (loupeminus_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.33 10.22a1 1 0 0 1-1 1H9.22a1 1 0 0 1 0-2h9.11a1 1 0 0 1 1 1Z"
  })));
};
/* harmony default export */ var loupeminus = ((/* unused pure expression or super */ null && (SvgLoupeminus)));
;// CONCATENATED MODULE: ./public/images/geo.svg
var geo_path;
function geo_extends() { geo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return geo_extends.apply(this, arguments); }

var SvgGeo = function SvgGeo(props) {
  return /*#__PURE__*/React.createElement("svg", geo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    strokeWidth: 2
  }, props), geo_path || (geo_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.37.64a1 1 0 0 0-1-.25L1 7.38a1 1 0 0 0-.1 1.84l9.25 4.64 4.63 9.24a1 1 0 0 0 .89.56h.08a1 1 0 0 0 .87-.68l7-21.32a1 1 0 0 0-.25-1.02Zm-11.58 12a1 1 0 0 0-.45-.44L4 8.52l17.1-5.61L15.48 20Z"
  })));
};
/* harmony default export */ var geo = ((/* unused pure expression or super */ null && (SvgGeo)));
;// CONCATENATED MODULE: ./public/images/fullscreen.svg
var fullscreen_path;
function fullscreen_extends() { fullscreen_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fullscreen_extends.apply(this, arguments); }

var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", fullscreen_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    strokeWidth: 2
  }, props), fullscreen_path || (fullscreen_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.83 14.81-5.37 5.33v-2.5a1 1 0 0 0-1-1 1 1 0 0 0-1 1l-.04 4.74a1 1 0 0 0 .28.71 1 1 0 0 0 .7.31l5 .09a1 1 0 0 0 0-2L4 21.44l5.26-5.21a1 1 0 0 0 0-1.41 1 1 0 0 0-1.43-.01ZM23.34 1l-.05-.09a1 1 0 0 0-.13-.09A1.37 1.37 0 0 0 23 .68a.58.58 0 0 0-.14 0 1 1 0 0 0-.27-.08l-5-.09a1 1 0 0 0-1 1 1 1 0 0 0 1 1l2.6.05-5.58 5.53a1 1 0 0 0 0 1.42 1 1 0 0 0 1.41 0l5.51-5.46v2.31a1 1 0 0 0 1 1 1 1 0 0 0 1-1l.08-4.77a.94.94 0 0 0-.27-.59ZM22.5 16.62a1 1 0 0 0-1 1v2.59L16 14.73a1 1 0 1 0-1.42 1.41L20 21.53h-2.31a1 1 0 0 0-1 1 1 1 0 0 0 1 1l4.78.09a1 1 0 0 0 .37-.08s.07-.05.11-.07a1.48 1.48 0 0 0 .21-.13.83.83 0 0 0 .15-.23s.05 0 .06-.09a1 1 0 0 0 .08-.37l.09-4.93a1 1 0 0 0-1.04-1.1ZM1.49 7.38a1 1 0 0 0 1-1L2.55 4l5.17 5.19a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.28 1 1 0 0 0 0-1.42L3.88 2.47h2.48a1 1 0 0 0 1-1 1 1 0 0 0-1-1L1.62.42A1.15 1.15 0 0 0 .91.7a1 1 0 0 0-.31.71l-.09 5a1 1 0 0 0 .98.97Z"
  })));
};
/* harmony default export */ var fullscreen = ((/* unused pure expression or super */ null && (SvgFullscreen)));
;// CONCATENATED MODULE: ./components/objects/ObjectsMap.js




























var TemplateProvider = (0,react_yandex_maps_esm/* withYMaps */.XU)(function(param) {
    var children = param.children, template = param.template;
    return children({
        template: template
    });
}, true, [
    "templateLayoutFactory"
]);
var polygonDefaults = {
    strokeColor: "#52bf41",
    strokeWidth: 3.5,
    fillColor: "#52bf41",
    fillOpacity: 0.2,
    interactivityModel: "default#transparent"
};
var isAnyFilters = function(s) {
    var arrFilters = [
        "priceFrom",
        "priceTo",
        "rooms",
        "studio",
        "squareFrom",
        "squareTo",
        "mikroraion",
        "squareAreaFrom",
        "squareAreaTo",
        "commercialType",
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "ceiling",
        "balcony",
        "renovation",
        "bathroom",
        "buildingType",
        "stock",
        "lotType",
        "subCategory",
        "entrance",
        "commercialBuildingType"
    ];
    var filtersTotal = 0;
    for(var i = 0; i < arrFilters.length; i++)if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
    return filtersTotal > 0;
};
var ObjectsMap = function() {
    /** STATES */ var router = (0,next_router.useRouter)();
    var isMount = (0,useIsMount/* useIsMount */.z)();
    var locationState = (0,context_location/* useLocationState */.KJ)();
    var width = (0,useWindowDimensions/* default */.Z)().width;
    var ref = (0,_sliced_to_array/* default */.Z)((0,objects/* useObjectsProvider */.v8)(), 2), objectsState = ref[0], setObjectsState = ref[1];
    var ref1 = (0,react.useState)(), ymaps = ref1[0], setYmaps = ref1[1];
    var ref2 = (0,react.useState)(false), isMapReady = ref2[0], setIsMapReady = ref2[1];
    var ref3 = (0,react.useState)(true), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(Boolean(objectsState.map.searchZone.length)), isDrawing = ref4[0], setIsDrawing = ref4[1];
    var ref5 = (0,react.useState)(objectsState.map.searchZone), drawPolygon = ref5[0], setDrawPolygon = ref5[1];
    var ref6 = (0,react.useState)([]), objectManagerFeatures = ref6[0], setObjectManagerFeatures = ref6[1];
    var ref7 = (0,react.useState)(), clickedActivePoint = ref7[0], setClickedActivePoint = ref7[1];
    var ref8 = (0,react.useState)(locationState.zoom), zoomLevel = ref8[0], setZoomLevel = ref8[1];
    /** REFS */ var mapId = (0,react.useRef)();
    var drawButtonId = (0,react.useRef)();
    /** FUNCTIONS */ var drawCustomPolygon = function(y) {
        var rect = y.container.getParentElement().getBoundingClientRect();
        var canvas = document.createElement("canvas");
        var ctx2d = canvas.getContext("2d");
        var isDrawing = false;
        var coordinates = [];
        var offsets = [];
        /** Setting canvas same size as map element. */ canvas.style.width = "".concat(rect.width, " px");
        canvas.style.height = "".concat(rect.height, " px");
        canvas.style.zIndex = "50000";
        canvas.style.position = "fixed";
        canvas.style.right = 0;
        canvas.style.bottom = 0;
        canvas.style.left = 0;
        canvas.style.top = 0;
        canvas.style.opacity = 1;
        canvas.width = rect.width;
        canvas.height = rect.height;
        /** Setting styles. */ ctx2d.strokeStyle = polygonDefaults.strokeColor;
        ctx2d.lineWidth = polygonDefaults.strokeWidth;
        y.panes.get("overlaps").getElement().append(canvas);
        var onDown = function(e) {
            isDrawing = true;
            coordinates.push([
                e.pageX,
                e.pageY
            ]);
            offsets.push([
                e.offsetX || e.clientX - rect.left,
                e.offsetY || e.clientY - rect.top
            ]);
        };
        var onMove = function(e) {
            if (!isDrawing) return;
            var last = offsets[offsets.length - 1];
            ctx2d.beginPath();
            ctx2d.moveTo(last[0], last[1]);
            ctx2d.lineTo(e.offsetX || e.clientX - rect.left, e.offsetY || e.clientY - rect.top);
            ctx2d.stroke();
            coordinates.push([
                e.pageX,
                e.pageY
            ]);
            offsets.push([
                e.offsetX || e.clientX - rect.left,
                e.offsetY || e.clientY - rect.top
            ]);
        };
        var onUp = function() {
            canvas.parentNode.removeChild(canvas);
            isDrawing = false;
            var projection = y.options.get("projection");
            coordinates = coordinates.map(function(x) {
                return projection.fromGlobalPixels(y.converter.pageToGlobal([
                    x[0],
                    x[1]
                ]), y.getZoom());
            });
            return coordinates;
        };
        canvas.onmousedown = function(e) {
            return onDown(e);
        };
        canvas.ontouchstart = function(e) {
            e.preventDefault();
            onDown(e.touches[0]);
        };
        canvas.onmousemove = function(e) {
            return onMove(e);
        };
        canvas.ontouchmove = function(e) {
            e.preventDefault();
            onMove(e.touches[0]);
        };
        return new Promise(function(resolve) {
            /** When mouse up saving coordinates and hiding canvas. */ canvas.onmouseup = function(e) {
                if (coordinates.length > 10) resolve(onUp(e));
                ctx2d.clearRect(0, 0, canvas.width, canvas.height);
                offsets = [];
                coordinates = [];
                isDrawing = false;
            };
            canvas.ontouchend = function(e) {
                if (coordinates.length > 10) resolve(onUp(e));
                ctx2d.clearRect(0, 0, canvas.width, canvas.height);
                offsets = [];
                coordinates = [];
                isDrawing = false;
            };
        });
    };
    var handleCatalogBackClick = function() {
        var newLink = "/" + router.query.region + "/objects";
        switch(objectsState.filter.type){
            default:
            case "продажа":
                newLink += "/buy";
                break;
            case "аренда":
                newLink += "/rent";
                break;
        }
        switch(objectsState.filter.category){
            default:
            case "квартира":
                newLink += "/flats";
                break;
            case "комната":
                newLink += "/rooms";
                break;
            case "дом":
                newLink += "/houses";
                break;
            case "участок":
                newLink += "/sites";
                break;
            case "коммерция":
                newLink += "/commercial";
                break;
        }
        if (!objectsState.filter.studio && objectsState.filter.rooms.length === 1) {
            switch(objectsState.filter.rooms[0]){
                case "1":
                    newLink += "/1k";
                    break;
                case "2":
                    newLink += "/2k";
                    break;
                case "3":
                    newLink += "/3k";
                    break;
                case "4":
                    newLink += "/4k";
                    break;
                default:
                    break;
            }
        } else if (objectsState.filter.studio && !objectsState.filter.rooms.length) {
            newLink += "/studio";
        }
        setObjectsState({
            type: "SET_FILTER",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter), {
                ads: []
            })
        });
        router.push("".concat(newLink).concat((0,helpers/* JSONToQuery */.vp)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.pagination, objectsState.sorting), [
            "type",
            "category",
            "length",
            "ads",
            objectsState.filter.studio && !objectsState.filter.rooms.length && "studio",
            !objectsState.filter.studio && objectsState.filter.rooms.length === 1 && "rooms"
        ], [
            "page=1",
            "sort=last-update.date"
        ], true)));
    };
    var handleMapLoad = function(e) {
        setYmaps(e);
        setIsMapReady(true);
        setIsLoading(false);
        setObjectsState({
            type: "SET_MAP",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.map), {
                bbox: mapId.current.getBounds()
            })
        });
    };
    var handleOnBoundsChange = function(e) {
        setZoomLevel(e.originalEvent.newZoom);
        setObjectsState({
            type: "SET_MAP",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.map), {
                bbox: mapId.current.getBounds(),
                zoomLevel: e.originalEvent.newZoom
            })
        });
        router.replace("/".concat(router.query.region, "/objects/map").concat((0,helpers/* JSONToQuery */.vp)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.map), [
            "bbox",
            "zoomLevel",
            "ads"
        ], [], true)));
    };
    var handleClickOnPoint = function(e) {
        var currentZoom = mapId.current.getZoom();
        var target = e.originalEvent.currentTarget.clusters.getById(e.get("objectId")) || e.originalEvent.currentTarget.objects.getById(e.get("objectId"));
        if (currentZoom < 14.5) {
            mapId.current.setCenter(target.type === "Cluster" ? ymaps.util.bounds.getCenter(target.bbox) : target.geometry.coordinates, 15, {
                duration: 300
            });
        } else {
            setClickedActivePoint(target);
            setObjectsState({
                type: "SET_FILTER",
                payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter), {
                    ads: target.properties.clusterObjects || [
                        target.id
                    ]
                })
            });
            setObjectsState({
                type: "SET_STATE",
                payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.state), {
                    isMapCatalogVisible: true
                })
            });
            router.replace("/".concat(router.query.region, "/objects/map").concat((0,helpers/* JSONToQuery */.vp)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.map), {
                ads: target.properties.clusterObjects || [
                    target.id
                ]
            }), [
                "bbox",
                "zoomLevel",
                "ads"
            ], [], true)));
        }
    };
    var handleDrawButtonClick = function() {
        setIsDrawing(!isDrawing);
        setDrawPolygon([]);
        setObjectsState({
            type: "SET_MAP",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.map), {
                searchZone: []
            })
        });
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        if (isMount) return;
        if (isDrawing) {
            /** If want to draw. */ drawCustomPolygon(mapId.current).then(function(coordinates) {
                var cuttedCoordinates = coordinates.filter(function(_, i) {
                    return i % 3 === 0;
                });
                var unkinkPolygons = (0,dist_es/* default */.Z)({
                    type: "Feature",
                    geometry: {
                        type: "Polygon",
                        coordinates: [
                            cuttedCoordinates
                        ]
                    }
                }, {
                    tolerance: 1e-7
                });
                var cleanedPolygon = (0,es/* default */.Z)((0,buffer_dist_es/* default */.Z)((0,combine_dist_es/* default */.Z)(unkinkPolygons), 1e-12).features[0]).geometry.coordinates;
                var sizedPolygon = cleanedPolygon[0].map(function(v) {
                    return [
                        Number(v[0].toFixed(5)),
                        Number(v[1].toFixed(5))
                    ];
                });
                var newMapState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.map), {
                    searchZone: sizedPolygon
                });
                setDrawPolygon(sizedPolygon);
                setObjectsState({
                    type: "SET_MAP",
                    payload: newMapState
                });
                router.replace("/".concat(router.query.region, "/objects/map").concat((0,helpers/* JSONToQuery */.vp)((0,_object_spread/* default */.Z)({}, objectsState.filter, newMapState), [
                    "bbox",
                    "zoomLevel",
                    "ads"
                ], [], true)));
            });
        } else {
            setDrawPolygon([]);
            setObjectsState({
                type: "SET_MAP",
                payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.map), {
                    searchZone: []
                })
            });
            router.replace("/".concat(router.query.region, "/objects/map").concat((0,helpers/* JSONToQuery */.vp)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter, objectsState.map), {
                searchZone: []
            }), [
                "bbox",
                "zoomLevel",
                "ads"
            ], [], true)));
        }
    }, [
        isDrawing
    ]);
    (0,react.useEffect)(function() {
        var controller = new AbortController();
        var signal = controller.signal;
        if (!objectsState.filter.ads.length) setClickedActivePoint();
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var request;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return axios_default().post("https://baza.estate/api/v2" + "/objects/map", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.filter), {
                                bbox: objectsState.map.bbox,
                                zoom: objectsState.map.zoomLevel,
                                searchZone: objectsState.map.searchZone,
                                location: locationState.region,
                                ads: []
                            }), {
                                signal: signal
                            });
                        case 3:
                            request = _ctx.sent;
                            if (request.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Something wrong with getting server data! [ObjectsMap -> fetchData()]");
                        case 6:
                            setObjectManagerFeatures(request.data.features);
                            _ctx.next = 11;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        objectsState.filter,
        objectsState.map.bbox,
        objectsState.map.searchZone
    ]);
    (0,react.useEffect)(function() {
        if (isMount || drawPolygon.length) return;
        if (mapId.current) mapId.current.setCenter(locationState.coordinates, locationState.zoom);
    }, [
        locationState
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: [
            "block",
            "clear",
            (ObjectsMap_module_default()).map
        ].join(" "),
        children: [
            isLoading && !isMapReady && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ObjectsMap_module_default()).loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/loading_map.svg",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Загрузка картографических данных..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_yandex_maps_esm/* YMaps */.Yy, {
                query: {
                    apikey: "30499cc5-6350-4442-960c-6c0de5a8ad59"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateProvider, {
                        children: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_yandex_maps_esm/* Map */.D5, {
                                modules: [
                                    "util.bounds"
                                ],
                                style: {
                                    width: "100%",
                                    height: "100%"
                                },
                                defaultState: {
                                    center: locationState.coordinates,
                                    zoom: locationState.zoom,
                                    controls: [],
                                    behaviors: [
                                        "drag",
                                        "dblClickZoom",
                                        "multiTouch",
                                        "scrollZoom"
                                    ],
                                    margin: [
                                        0,
                                        0,
                                        0,
                                        width > 992 && objectsState.state.isMapCatalogVisible ? 420 : 0
                                    ]
                                },
                                defaultOptions: {
                                    maxZoom: 20,
                                    maxAnimationZoomDifference: Infinity,
                                    autoFitToViewport: "always",
                                    yandexMapDisablePoiInteractivity: true,
                                    suppressObsoleteBrowserNotifier: true,
                                    suppressMapOpenBlock: true
                                },
                                onLoad: handleMapLoad,
                                onBoundschange: handleOnBoundsChange,
                                instanceRef: function(ref) {
                                    if (ref) mapId.current = ref;
                                },
                                children: [
                                    isMapReady && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            clickedActivePoint && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* Placemark */.ah, {
                                                geometry: clickedActivePoint.geometry.coordinates,
                                                options: clickedActivePoint.type === "Cluster" ? {
                                                    iconLayout: ymaps.templateLayoutFactory.createClass('\n                          <div class="point cluster active">\n                            <div class="information">от '.concat(clickedActivePoint.priceText, "</div>\n                            ").concat(clickedActivePoint.properties.clusterInfo, "\n                          </div>")),
                                                    iconShape: zoomLevel > 14.5 ? {
                                                        type: "Rectangle",
                                                        coordinates: [
                                                            [
                                                                -38,
                                                                -26
                                                            ],
                                                            [
                                                                62,
                                                                22
                                                            ]
                                                        ]
                                                    } : {
                                                        type: "Circle",
                                                        coordinates: [
                                                            12,
                                                            12
                                                        ],
                                                        radius: 11
                                                    },
                                                    iconOffset: [
                                                        -12,
                                                        -12
                                                    ],
                                                    zIndex: 10
                                                } : {
                                                    iconLayout: ymaps.templateLayoutFactory.createClass('<div class="point active">\n                            <div class="information">'.concat(clickedActivePoint.priceText, "</div>\n                          </div>")),
                                                    iconShape: zoomLevel > 14.5 ? {
                                                        type: "Rectangle",
                                                        coordinates: [
                                                            [
                                                                -28,
                                                                -26
                                                            ],
                                                            [
                                                                52,
                                                                14
                                                            ]
                                                        ]
                                                    } : {
                                                        type: "Circle",
                                                        coordinates: [
                                                            8,
                                                            8
                                                        ],
                                                        radius: 7
                                                    },
                                                    iconOffset: [
                                                        -6,
                                                        -6
                                                    ],
                                                    zIndex: 10
                                                }
                                            }),
                                            Boolean(drawPolygon.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* Polygon */.mg, {
                                                geometry: [
                                                    drawPolygon
                                                ],
                                                options: polygonDefaults
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* ObjectManager */.aP, {
                                                objects: {
                                                    iconLayout: ymaps.templateLayoutFactory.createClass(zoomLevel > 14.5 ? '\n                          <div class="point">\n                            {% if price > 0 %}\n                            <div class="information">{{priceText}}</div>\n                            {% endif %}\n                          </div>\n                        ' : '\n                          <div class="point"></div>\n                        '),
                                                    iconShape: zoomLevel > 14.5 ? {
                                                        type: "Rectangle",
                                                        coordinates: [
                                                            [
                                                                -28,
                                                                -26
                                                            ],
                                                            [
                                                                52,
                                                                14
                                                            ]
                                                        ]
                                                    } : {
                                                        type: "Circle",
                                                        coordinates: [
                                                            8,
                                                            8
                                                        ],
                                                        radius: 7
                                                    },
                                                    iconOffset: [
                                                        -6,
                                                        -6
                                                    ],
                                                    hasBalloon: false,
                                                    zIndex: 6
                                                },
                                                clusters: {
                                                    clusterIconLayout: ymaps.templateLayoutFactory.createClass(zoomLevel > 14.5 ? '\n                          <div class="point cluster">\n                            {% if price > 0 %}\n                            <div class="information">от {{priceText}}</div>\n                            {% endif %}\n                            {% if properties.clusterInfo < 100 %}\n                            {{properties.clusterInfo}}\n                            {% else %}\n                            99\n                            {% endif %}\n                          </div>\n                        ' : '\n                          <div class="point cluster">\n                            {% if properties.clusterInfo < 100 %}\n                            {{properties.clusterInfo}}\n                            {% else %}\n                            99\n                            {% endif %}\n                          </div>\n                        '),
                                                    clusterIconShape: zoomLevel > 14.5 ? {
                                                        type: "Rectangle",
                                                        coordinates: [
                                                            [
                                                                -38,
                                                                -26
                                                            ],
                                                            [
                                                                62,
                                                                22
                                                            ]
                                                        ]
                                                    } : {
                                                        type: "Circle",
                                                        coordinates: [
                                                            12,
                                                            12
                                                        ],
                                                        radius: 11
                                                    },
                                                    clusterIconOffset: [
                                                        -12,
                                                        -12
                                                    ],
                                                    zIndex: 6
                                                },
                                                options: {
                                                    clusterize: false,
                                                    clusterDisableClickZoom: true
                                                },
                                                features: objectManagerFeatures,
                                                onClick: handleClickOnPoint
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* Button */.zx, {
                                        options: {
                                            position: width > 992 ? {
                                                top: 12,
                                                right: 72
                                            } : {
                                                top: 12,
                                                left: 12
                                            },
                                            maxWidth: "none",
                                            selectOnClick: false
                                        },
                                        data: {
                                            content: '<div style="margin: 0 18px;display:flex;"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke-width="2"><path d="M2.88,3a2.31,2.31,0,1,0,2.3,2.31A2.31,2.31,0,0,0,2.88,3Z"/><path d="M8.59,6.27H22.77a1,1,0,0,0,0-2H8.59a1,1,0,0,0,0,2Z"/><path d="M2.88,9.69A2.31,2.31,0,1,0,5.18,12,2.31,2.31,0,0,0,2.88,9.69Z"/><path d="M22.77,11H8.59a1,1,0,0,0,0,2H22.77a1,1,0,0,0,0-2Z"/><path d="M2.88,16.42a2.31,2.31,0,1,0,2.3,2.31A2.3,2.3,0,0,0,2.88,16.42Z"/><path d="M22.77,17.73H8.59a1,1,0,0,0,0,2H22.77a1,1,0,0,0,0-2Z"/></svg></div>'
                                        },
                                        onClick: handleCatalogBackClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* Button */.zx, {
                                        options: {
                                            position: width > 992 ? {
                                                top: 132,
                                                right: 12
                                            } : {
                                                bottom: 32,
                                                right: 12
                                            },
                                            selectOnClick: false
                                        },
                                        data: {
                                            content: "".concat(isAnyFilters(objectsState.filter) ? '<span style="position: absolute; right: 8px; bottom: 8px; background-color: #E8505B; width: 8px; height: 8px; border-radius: 50%;"></span>' : "", '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke-width="2"><path d="M22.63.18H1.37a1,1,0,0,0-1,1V5a1,1,0,0,0,1,1H2l7.27,9.1v7.69a1,1,0,0,0,1,1h3.44a1,1,0,0,0,1-1V15.13L22,6h.64a1,1,0,0,0,1-1V1.18A1,1,0,0,0,22.63.18Zm-9.91,14.6v7H11.28v-7a1,1,0,0,0-.22-.62L4.57,6H19.43l-6.49,8.13A1,1,0,0,0,12.72,14.78ZM2.37,4V2.18H21.63V4H2.37Z"/></svg>')
                                        },
                                        onClick: function() {
                                            return setObjectsState({
                                                type: "SET_STATE",
                                                payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, objectsState.state), {
                                                    isFiltersMobileVisible: true
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* GeolocationControl */.Bo, {
                                        options: {
                                            position: width > 992 ? {
                                                right: 12,
                                                top: 12
                                            } : {
                                                right: 12,
                                                top: 12
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* Button */.zx, {
                                        options: {
                                            position: width > 992 ? {
                                                top: 72,
                                                right: 12
                                            } : {
                                                bottom: 90,
                                                right: 12
                                            }
                                        },
                                        data: {
                                            content: Boolean(drawPolygon.length) || isDrawing ? '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke-width="2"><path d="M17.87,9.64a2.43,2.43,0,0,0-.61.08A2.45,2.45,0,0,0,15,8.22a2.32,2.32,0,0,0-.92.18,2.51,2.51,0,0,0-2.37-.94V4.05a2.43,2.43,0,0,0-4.86,0v8.82l-.4-.39a2.84,2.84,0,0,0-3.94,0,2.09,2.09,0,0,0,0,2.93L9,21.89a6.71,6.71,0,0,0,11.27-4.34l0-5.47A2.43,2.43,0,0,0,17.87,9.64Zm.41,7.8a4.71,4.71,0,0,1-7.89,3L3.94,14v-.11a.76.76,0,0,1,.55-.23.79.79,0,0,1,.56.23L7.15,16a1,1,0,0,0,1.09.22,1,1,0,0,0,.62-.93V4.05a.43.43,0,0,1,.86,0v8a1,1,0,0,0,2,0V9.85a.42.42,0,0,1,.43-.42.43.43,0,0,1,.43.43v.79h0V12a1,1,0,0,0,2,0V10.64a.43.43,0,0,1,.86,0V12a1,1,0,0,0,.46.84l.1.06a1,1,0,0,0,1,0,1,1,0,0,0,.48-.83.44.44,0,0,1,.43-.42.43.43,0,0,1,.43.43Z"/><path d="M22.06,5.43a6.49,6.49,0,0,0-9.61-4.25,1,1,0,0,0-.36,1.37,1,1,0,0,0,1.36.36,4.5,4.5,0,0,1,6.66,2.94,1,1,0,0,0,1,.79l.21,0A1,1,0,0,0,22.06,5.43Z"/></svg>'
                                        },
                                        defaultState: {
                                            selected: Boolean(drawPolygon.length) || isDrawing
                                        },
                                        instanceRef: function(ref) {
                                            if (ref) drawButtonId.current = ref;
                                        },
                                        onClick: handleDrawButtonClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* ZoomControl */.Ly, {
                                        options: {
                                            position: {
                                                right: "12px",
                                                top: "calc(50vh - 104px)"
                                            },
                                            size: "small"
                                        }
                                    })
                                ]
                            });
                        }
                    }),
                    width > 992 && isMapReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalog, {}),
                    width < 992 && isMapReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMapCatalogMobile, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var objects_ObjectsMap = (ObjectsMap);

// EXTERNAL MODULE: ./components/objects/ObjectsFilterMobile.js
var ObjectsFilterMobile = __webpack_require__(1568);
;// CONCATENATED MODULE: ./pages/[region]/objects/map.js








var ObjectsMapPage = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,context_location/* useLocationProvider */.b8)(), 1), locationState = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: locationState.seo.title,
                description: locationState.seo.description,
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: locationState.seo.title,
                    description: locationState.seo.description,
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "core",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ObjectsFilterMobile/* default */.Z, {
                        isMap: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(objects_ObjectsMap, {})
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var map = (ObjectsMapPage);


/***/ }),

/***/ 6458:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__K_OGY","wrapper":"Modal_wrapper__GApcg","modalClose":"Modal_modalClose__JjTro","modal":"Modal_modal__zDdHS","modalTitle":"Modal_modalTitle___5XER","modalContent":"Modal_modalContent__StIgw","modalButton":"Modal_modalButton__M288p","no-animation":"Modal_no-animation__WAarP","no-border":"Modal_no-border__M3CJz","fullWidth":"Modal_fullWidth__UVGPG"};

/***/ }),

/***/ 2901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"map":"ObjectsMap_map__bgAtq","loading":"ObjectsMap_loading__3ndub"};

/***/ }),

/***/ 2601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ObjectsMapCatalog_wrapper__riDRt","catalog":"ObjectsMapCatalog_catalog__PZtUi","catalogHeader":"ObjectsMapCatalog_catalogHeader__HDo2R","catalogContent":"ObjectsMapCatalog_catalogContent__PFpEm","catalogFooter":"ObjectsMapCatalog_catalogFooter__GUYku","switch":"ObjectsMapCatalog_switch__t3BI1"};

/***/ }),

/***/ 8960:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commercial":"ObjectsMapCatalogCommercialItem_commercial__K3NjY","commercialContent":"ObjectsMapCatalogCommercialItem_commercialContent__lW2mw","comemrcialTitle":"ObjectsMapCatalogCommercialItem_comemrcialTitle___W0z4","comemrcialDescription":"ObjectsMapCatalogCommercialItem_comemrcialDescription__4URR5"};

/***/ }),

/***/ 2342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"ObjectsMapCatalogItem_item__VIGZi","itemGallery":"ObjectsMapCatalogItem_itemGallery__Dlysc","itemGalleryCounter":"ObjectsMapCatalogItem_itemGalleryCounter__n6yOy","itemGalleryButtons":"ObjectsMapCatalogItem_itemGalleryButtons__e1sbG","itemGalleryButtonLeft":"ObjectsMapCatalogItem_itemGalleryButtonLeft__URVQY","itemGalleryButtonRight":"ObjectsMapCatalogItem_itemGalleryButtonRight__SV0kl","itemGalleryPhotos":"ObjectsMapCatalogItem_itemGalleryPhotos__zmLdx","itemGalleryPhoto":"ObjectsMapCatalogItem_itemGalleryPhoto__FkmRt","itemGalleryPhotoHash":"ObjectsMapCatalogItem_itemGalleryPhotoHash__tEktT","itemGalleryPhotoMore":"ObjectsMapCatalogItem_itemGalleryPhotoMore__e9PyI","itemGalleryPhotoMoreText":"ObjectsMapCatalogItem_itemGalleryPhotoMoreText__wcxIm","itemLabels":"ObjectsMapCatalogItem_itemLabels__P_Au4","itemLabelsItem":"ObjectsMapCatalogItem_itemLabelsItem__Z0HJ8","yellow":"ObjectsMapCatalogItem_yellow__1v70W","red":"ObjectsMapCatalogItem_red__76AGL","itemData":"ObjectsMapCatalogItem_itemData__Do63N","itemPrice":"ObjectsMapCatalogItem_itemPrice__vuCTL","itemActionsFavorites":"ObjectsMapCatalogItem_itemActionsFavorites__WvEBT","active":"ObjectsMapCatalogItem_active__Ew29R","itemAddress":"ObjectsMapCatalogItem_itemAddress__ofTNr","itemProperties":"ObjectsMapCatalogItem_itemProperties__u6hKM","itemProperty":"ObjectsMapCatalogItem_itemProperty__FLrDI","itemActions":"ObjectsMapCatalogItem_itemActions__rMvXz","qr":"ObjectsMapCatalogItem_qr___TSqW"};

/***/ }),

/***/ 8060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"catalog":"ObjectsMapCatalogMobile_catalog__7XJn0","catalogHeader":"ObjectsMapCatalogMobile_catalogHeader__mTt_P"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3715,41,2962,5518,482,798,360,1034,9774,2888,179], function() { return __webpack_exec__(5080); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);